import { ReactElement } from 'react';

import { WaitlistEntry } from '@dreryk/egabinet-waitlist-frontend-api';

import { StrongText, StyledFlex, Text, TextSeparator, TextSeparatorType } from '@dreryk/react-components';
import { commonTranslationKeys, Translate } from '@dreryk/react-common';

import { waitlistEntryTranslationKeys } from '../../../../translations';

import {
   getPatientAvailabilityDays,
   isAllPatientAvailabilityTimesSelected,
   sortPatientAvailabilityTimesByDayOrder,
} from './WaitlistEntrySection.utils';

type PatientAvailabilityPreferredDatesProps = {
   readonly patientAvailability: WaitlistEntry['patientAvailability'];
};

export const PatientAvailabilityPreferredDates = (props: PatientAvailabilityPreferredDatesProps): ReactElement => {
   const availableDays = getPatientAvailabilityDays(props.patientAvailability);

   return (
      <StyledFlex direction='column'>
         {availableDays.map((day) => {
            const times = props.patientAvailability[day]!;

            return (
               <TextSeparator key={day} separator={TextSeparatorType.SPACE}>
                  <StrongText testId={day}>
                     <Translate>{commonTranslationKeys.dayOfWeekAbbreviationMap[day]}</Translate>
                  </StrongText>
                  {isAllPatientAvailabilityTimesSelected(times) ? (
                     <Text testId={'noRestrictions'}>
                        <Translate>{waitlistEntryTranslationKeys.noRestrictions}</Translate>
                     </Text>
                  ) : (
                     <Text testId={'times'}>
                        <TextSeparator separator={TextSeparatorType.COMMA_SPACE}>
                           {sortPatientAvailabilityTimesByDayOrder(times).map((time) => (
                              <Translate key={time}>{waitlistEntryTranslationKeys.timeOfDayMap[time]}</Translate>
                           ))}
                        </TextSeparator>
                     </Text>
                  )}
               </TextSeparator>
            );
         })}
      </StyledFlex>
   );
};
